import { render } from "./IosManualCard.vue?vue&type=template&id=d0cb4eaa&scoped=true"
import script from "./IosManualCard.vue?vue&type=script&lang=js"
export * from "./IosManualCard.vue?vue&type=script&lang=js"

import "./IosManualCard.vue?vue&type=style&index=0&id=d0cb4eaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0cb4eaa"]])

export default __exports__